import React from 'react';

import { SEO } from 'main/components';
import {
  Cards,
  CTA,
  CtrlPass,
  DlcCarousel,
  EduEnterprise,
  Landing,
  LogosLayout,
  ProductFacts,
} from 'modules/skydive';

export const Skydive = () => {
  return (
    <>
      <SEO seoTitle="FPV SkyDive - Realistic Flight Simulator for Drone Racing - Orqa" />
      <section className="skydive-section">
        <Landing />
        <Cards />
        <EduEnterprise />
        <LogosLayout />
        <DlcCarousel />
        <ProductFacts />
        <CtrlPass />
        <CTA />
      </section>
    </>
  );
};
